var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("e-sidebar", {
        attrs: {
          title: _vm.edit
            ? _vm.$t("Editar item calendário")
            : _vm.$t("Novo item calendário"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: { save: _vm.saveCalendarLocal, hidden: _vm.cancel },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "FormulateForm",
                      { ref: "form", attrs: { name: "form" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "calendar-name",
                                    label: _vm.$t("Nome"),
                                    type: "text",
                                    validation: "required",
                                    maxlength: "200",
                                  },
                                  model: {
                                    value: _vm.formCalendar.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formCalendar, "name", $$v)
                                    },
                                    expression: "formCalendar.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "calendar-type",
                                    label: _vm.$t("Tipo"),
                                    type: "vue-select",
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.calendarTypes,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.formCalendar.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formCalendar, "type", $$v)
                                    },
                                    expression: "formCalendar.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "calendar-province",
                                    label: _vm.$t("Estado"),
                                    type: "vue-select",
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.provinceOptions,
                                    multiple: true,
                                  },
                                  on: { input: _vm.onProvinceChange },
                                  model: {
                                    value: _vm.formCalendar.provinces,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formCalendar,
                                        "provinces",
                                        $$v
                                      )
                                    },
                                    expression: "formCalendar.provinces",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "calendar-city",
                                    label: _vm.$t("Cidade"),
                                    type: "vue-select",
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.cityOptions,
                                    multiple: true,
                                  },
                                  model: {
                                    value: _vm.formCalendar.cities,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formCalendar, "cities", $$v)
                                    },
                                    expression: "formCalendar.cities",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("EStoreCombo", {
                                  attrs: {
                                    id: "calendar-store",
                                    label: _vm.$t("Lojas"),
                                    placeholder: _vm.$t("Todas as lojas"),
                                    multiple: true,
                                    required: false,
                                    filter: _vm.getStoreFilter,
                                  },
                                  model: {
                                    value: _vm.formCalendar.stores,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formCalendar, "stores", $$v)
                                    },
                                    expression: "formCalendar.stores",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "calendar-start-date",
                                    label: _vm.$t("Data de Início"),
                                    type: "datepicker",
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.formCalendar.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formCalendar,
                                        "startDate",
                                        $$v
                                      )
                                    },
                                    expression: "formCalendar.startDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "calendar-end-date",
                                    label: _vm.$t("Data de Término"),
                                    type: "datepicker",
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.formCalendar.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formCalendar, "endDate", $$v)
                                    },
                                    expression: "formCalendar.endDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "calendar-description",
                                    label: _vm.$t("Descrição"),
                                    type: "textarea",
                                    rows: "2",
                                    maxlength: "400",
                                  },
                                  model: {
                                    value: _vm.formCalendar.description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formCalendar,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "formCalendar.description",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "calendar-purchase-factor",
                                    label: _vm.$t("Fator de Compra"),
                                    type: "text-number",
                                    precision: 2,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.formCalendar.purchaseFactor,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formCalendar,
                                        "purchaseFactor",
                                        $$v
                                      )
                                    },
                                    expression: "formCalendar.purchaseFactor",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }